// Libs
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Container, Row, Col } from '../../components/Elemental'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'

// CSS
import './styles.scss'

// Components/Containers
import Button from '../../components/Button'
import Form from '../../components/Form'
import Input from '../../components/Input'
import Warning from '../Warning'

// Validate
import * as validate from '../../constants/validate'

// Actions
import { changePopUp, changePopUpError } from './actions'
import { profile } from '../ProfilePage/actions'

class PopUp extends Component {
  handleFormSubmit = (reduxFormData) => {
    const { changePopUp, profile, action, changePopUpError, popUpError } = this.props

    switch (action) {
      case 'change password':
        profile(reduxFormData)
          .then(() => {
            changePopUp(false, '')
          })
        break;
      case 'amil':
        profile(reduxFormData)
          .then(() => {
            changePopUp(false, '')
          }).catch(e => {
            changePopUpError(e.errors.password)
          })
        break;
      default:
    }
  }

  renderFormFields = (action) => {
    let formFields

    switch (action) {
      case 'change password':
        formFields = (
          <Row>
            <Col>
              <Field
                component={Input}
                name="password"
                type="password"
                label="Senha"
                gutter={15}
                validate={validate.validatePassword} />
            </Col>
            <Col>
              <Field
                component={Input}
                name="passwordConfirm"
                type="password"
                label="Confirmar Senha"
                gutter={15}
                validate={validate.validatePassword} />
            </Col>
          </Row>
        )
        break;
      case 'amil':
        formFields = (
          <Row>
            <Col>
              <Field
                component={Input}
                name="password"
                type="password"
                label="Senha"
                gutter={15}
                validate={validate.validatePassword} />
            </Col>
            <Col>
              <Field
                component={Input}
                name="passwordConfirm"
                type="password"
                label="Confirmar Senha"
                gutter={15}
                validate={validate.validatePassword} />
            </Col>
          </Row>
        )
        break;
      default:
    }

    return formFields;
  }

  render() {
    const { localLoading, visible, action, changePopUp, handleSubmit, popUpError } = this.props
    const { handleFormSubmit, renderFormFields } = this
    let title = ''
    let text = ''
    let button1 = ''
    let button2 = ''

    switch (action) {
      case 'change password':
        title = 'Redefina a sua senha'
        text = 'Por favor, por motivos de segurança recomendamos que você altere a sua senha padrão.'
        button1 = 'Redefinir'
        button2 = 'Redefinir depois'
        break;
      case 'amil':
        title = 'Sua senha expirou!'
        text = 'A cada 90 dias você deve trocar sua senha.'
        button1 = 'Redefinir'
        break;
      default:
    }

    return (
      <div className={visible ? "pop-up pop-up--visible" : "pop-up"}>
        <Container className="pop-up__container">
          <Row>
            <Col>
              <div className="pop-up__content">
                <p>{title}</p>
                <p>{text}</p>
                <Form onSubmit={handleSubmit(this.handleFormSubmit)}>
                  {renderFormFields(action)}
                  {popUpError &&
                    <div className='pop-up__error'>{popUpError}</div>}
                  {/* <NavLink> */}
                  <Button
                    type={'submit'}
                    localLoading={localLoading}
                    gutterTop={30}>
                    {button1}
                  </Button>
                  {/* </NavLink> */}
                  <Button onClick={() => changePopUp(false, '')} gutterTop={30}>
                    {button2}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const reduxFormValidate = (values) => {
  const errors = {}

  if (values.password !== values.passwordConfirm) {
    errors.passwordConfirm = 'Senhas não coincidem.'
  }

  if (['semprocesso', 'sem processo', 'com acordo', 'comacordo'].indexOf(values.password) !== -1) {
    errors.password = 'Senha inválida por questões de segurança.'
  }

  return errors
}

PopUp = reduxForm({
  form: 'popUp',
  validate: reduxFormValidate
})(PopUp)


PopUp = connect(
  (state, ownProps) => ({
    localLoading: state.app.localLoading,
    visible: state.popUp.visible,
    action: state.popUp.action,
    popUpError: state.popUp.popUpError
  }), { changePopUp, profile, changePopUpError })(PopUp)

export default PopUp
